export default "__VITE_ASSET__CuR3QWWR__"